"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16 6.66667L14.5333 0H1.46667L0.016 6.522L0 7.33333C0.0024178 7.97686 0.23945 8.59741 0.666667 9.07867V14C0.666667 14.5304 0.87738 15.0391 1.25245 15.4142C1.62753 15.7893 2.13623 16 2.66667 16H13.3333C13.8638 16 14.3725 15.7893 14.7475 15.4142C15.1226 15.0391 15.3333 14.5304 15.3333 14V9.07867C15.7606 8.59741 15.9976 7.97686 16 7.33333V6.66667ZM1.33333 6.73933L2.53333 1.33333H4.66667V4H6V1.33333H10V4H11.3333V1.33333H13.4667L14.6667 6.73933V7.33333C14.6667 7.68696 14.5262 8.02609 14.2761 8.27614C14.0261 8.52619 13.687 8.66667 13.3333 8.66667H12.6667C12.313 8.66667 11.9739 8.52619 11.7239 8.27614C11.4738 8.02609 11.3333 7.68696 11.3333 7.33333H10C10 7.68696 9.85952 8.02609 9.60948 8.27614C9.35943 8.52619 9.02029 8.66667 8.66667 8.66667H7.33333C6.97971 8.66667 6.64057 8.52619 6.39052 8.27614C6.14048 8.02609 6 7.68696 6 7.33333H4.66667C4.66667 7.68696 4.52619 8.02609 4.27614 8.27614C4.02609 8.52619 3.68696 8.66667 3.33333 8.66667H2.66667C2.31304 8.66667 1.97391 8.52619 1.72386 8.27614C1.47381 8.02609 1.33333 7.68696 1.33333 7.33333V6.73933ZM13.3333 14.6667H2.66667C2.48986 14.6667 2.32029 14.5964 2.19526 14.4714C2.07024 14.3464 2 14.1768 2 14V9.90533C2.21724 9.96537 2.4413 9.99718 2.66667 10H3.33333C3.71326 9.99877 4.08849 9.91587 4.43356 9.7569C4.77864 9.59794 5.0855 9.36663 5.33333 9.07867C5.58117 9.36663 5.88803 9.59794 6.23311 9.7569C6.57818 9.91587 6.9534 9.99877 7.33333 10H8.66667C9.04521 10.0002 9.41944 9.9196 9.76434 9.76359C10.1092 9.60758 10.4169 9.37975 10.6667 9.09533C10.9165 9.37975 11.2241 9.60758 11.569 9.76359C11.9139 9.9196 12.2881 10.0002 12.6667 10H13.3333C13.5587 9.99718 13.7828 9.96537 14 9.90533V14C14 14.1768 13.9298 14.3464 13.8047 14.4714C13.6797 14.5964 13.5101 14.6667 13.3333 14.6667Z",
    fill: fill
  }));
};

exports["default"] = _default;